// extracted by mini-css-extract-plugin
export var compactFilters = "_e8-4";
export var detailImage = "_e8-1";
export var dropdownContainer = "_e8-2";
export var imageContainer = "_e8-0";
export var selectedCard = "_e8-3";